import React from 'react';
import './FullImageCard.css';
import { Col, Row } from 'react-bootstrap';
import { BsCheckLg } from "react-icons/bs";
import { useTranslation } from 'react-i18next';

const FullimageCard = ({ imageSrc, title, subtitle, paragraph, listItems, model }) => {
    const { t } = useTranslation();
    const imageStyle = {
        width: '100%',
        height: '500px',
        objectFit: 'cover',
        padding: '0px',
    };

    const detectLinkType = (link) => {
        if (!link) return 'text';
        
        // Check if it's a PDF link
        if (link.toLowerCase().endsWith('.pdf')) {
            return 'pdf';
        }
        
        // Check if it's an external link
        if (link.startsWith('http://') || link.startsWith('https://')) {
            return 'external';
        }
        
        // If it starts with '/', it's an internal link
        if (link.startsWith('/')) {
            return 'internal';
        }

        return 'text';
    };

    const renderListItem = (item, index) => {
        if (model === 2 && typeof item === 'object') {
            const { text, link } = item;
            const type = detectLinkType(link);
            
            if (!link) {
                return (
                    <li key={index} className='fic-check-mark'>
                        <BsCheckLg />
                        <span> {t(text)}</span>
                    </li>
                );
            }

            const linkProps = {
                href: link,
                ...(type !== 'internal' && {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                })
            };

            return (
                <li key={index} className='fic-check-mark'>
                    <BsCheckLg />
                    <span style={{marginLeft:'5px'}}> 
                        <a {...linkProps} style={{textDecoration:'none', color:'#ffffff'}}>
                            {t(text)}{type === 'pdf' && ''}
                        </a>
                    </span>
                </li>
            );
        } else {
            // Default model 1 rendering
            return (
                <li key={index} className='fic-check-mark'>
                    <BsCheckLg />
                    <span> {t(item)}</span>
                </li>
            );
        }
    };

    return (
        <div className="fic-stage-container">
            <div className="fic-stage-image-container">
                <img
                    className='fic-img-center-stage'
                    src={imageSrc}
                    alt={title}
                    style={imageStyle}
                />
            </div>

            <Row className="fic-stage-text-container">
                <Col xs={12} sm={12} md={4} lg={4}>
                    <div className="fic-left-part">
                        <h2 className='fic-title'>{t(title)}</h2>
                        <h3 className='fic-subtitle'>{t(subtitle)}</h3>
                    </div>
                </Col>
                <Col xs={12} sm={12} md={8} lg={8}>
                    <div className="fic-right-part">
                        <p className='fic-para'>{t(paragraph)}</p>
                        <ul>
                            {listItems && listItems.map((item, index) => renderListItem(item, index))}
                        </ul>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default FullimageCard;
